(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zen-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STARTED = 'zhCountdownStarted';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function start(el) {
    if (el.dataset[STARTED]) return;
    var target = Date.parse(el.getAttribute('data-zh-target'));
    if (isNaN(target)) return;
    el.dataset[STARTED] = '1';

    var f = {
      d: el.querySelector('[data-zh="d"]'),
      h: el.querySelector('[data-zh="h"]'),
      m: el.querySelector('[data-zh="m"]'),
      s: el.querySelector('[data-zh="s"]')
    };
    if (!f.d || !f.h || !f.m || !f.s) return;

    var timer = null;

    function render() {
      var t = target - Date.now();
      if (t <= 0) t = 0;
      f.d.textContent = pad(Math.floor(t / 86400000));
      f.h.textContent = pad(Math.floor(t / 3600000) % 24);
      f.m.textContent = pad(Math.floor(t / 60000) % 60);
      f.s.textContent = pad(Math.floor(t / 1000) % 60);
      return t;
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function run() {
      stop();
      if (render() <= 0) return;
      timer = setInterval(function () {
        if (render() <= 0) stop();
      }, 1000);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { run(); }
    });

    run();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-zh-target]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zen-notify"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MSG = {
    invalid_email: 'Revisa tu correo.',
    invalid_phone: 'Revisa tu numero. Ejemplo: 668 885 3458',
    origin_not_allowed: 'No se pudo guardar. Avisale a la tienda.',
    server_not_configured: 'No se pudo guardar. Avisale a la tienda.',
    _default: 'No se pudo guardar. Intenta de nuevo en un momento.'
  };

  function onSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var endpoint = form.getAttribute('data-zn-endpoint');
    if (!endpoint) return;

    var btn = form.querySelector('[data-zn-submit]');
    var err = form.querySelector('[data-zn-err]');
    var ok = form.querySelector('[data-zn-ok]');
    var fields = form.querySelector('[data-zn-fields]');
    var label = btn ? btn.textContent : '';

    if (err) { err.hidden = true; err.textContent = ''; }
    if (btn) { btn.disabled = true; btn.textContent = 'Enviando...'; }

    var data = new FormData(form);
    var payload = {
      email: String(data.get('email') || ''),
      phone: String(data.get('phone') || ''),
      consent: !!data.get('consent'),
      source: form.getAttribute('data-zn-source') || '',
      website: String(data.get('website') || '')
    };

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().catch(function () { return { ok: false, error: '_default' }; });
      })
      .then(function (res) {
        if (res && res.ok) {
          if (fields) fields.hidden = true;
          if (ok) ok.hidden = false;
          return;
        }
        throw new Error((res && res.error) || '_default');
      })
      .catch(function (e2) {
        var code = e2 && e2.message ? e2.message : '_default';
        if (err) { err.textContent = MSG[code] || MSG._default; err.hidden = false; }
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  }

  function bind(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var forms = root.querySelectorAll('form[data-zn-form]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].getAttribute('data-zn-bound')) continue;
      forms[i].setAttribute('data-zn-bound', '1');
      forms[i].addEventListener('submit', onSubmit);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
